import { render, staticRenderFns } from "./PlayTopBarIcon.vue?vue&type=template&id=71cf84f6&"
import script from "./PlayTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./PlayTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports